import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@config/global';
import { environment } from '@enviroment/environment';

@Injectable({
  providedIn: 'root',
})
export class IndiceArrepentimientoFinanciero {
  private type_structure: any = {
    BLUE_DAYS: 'blue_days',
    BONO: 'bono',
  };

  constructor(
    private globals_var: Globals,
    private router: Router,
  ) {}

  IAF(): any {
    let date_today: any = new Date();
    let date_expired: any = new Date('2026-01-31T14:59:59');

    if (date_today < date_expired && this.hasRequiredQueryParams()) {
      let notificacion_params = {
        active: true,
        entity_name: this.globals_var.KOA,
        entity_id: this.globals_var.ID_KOA,
        term_promo: [90, 180, 360, 540, 720],
        bonus_blue_days: {
          type: 'porcentual',
          tag_name: 'IAF_2026_PORCENTUAL_020',
          percentage: 0.2,
          label: '+0.20%',
          min_amount: 50000,
          applies_to_any_term: true,
          terms_locked: [],
          start_at: new Date('2026-01-14T00:00:00'),
          end_at: new Date('2026-01-31T14:59:59'),
          terms_url: 'legal/bono/indice-arrepentimiento-financiero-2026',
          image_banner_publisher: 'images/web/ilustrations/regalo-con-bono.webp',
        },
      };

      return notificacion_params;
    }

    return {
      active: false,
    };
  }

  private hasRequiredQueryParams(): boolean {
    const queryParams = this.router.parseUrl(this.router.url).queryParams;

    const requiredParams = {
      medio: 'Prensa',
      accion: 'Codigo_QR',
      campana: 'IndiceArrepentimiento2026'
    };

    return Object.entries(requiredParams).every(([key, value]) => queryParams[key] === value);
  }
}
